import { render, staticRenderFns } from "./InputLabelPlaceholder.vue?vue&type=template&id=5a5b19fc&"
import script from "./InputLabelPlaceholder.vue?vue&type=script&lang=js&"
export * from "./InputLabelPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports